import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import store from './store'
import router from './router'
import './utils/rem.js'
import './assets/fonts.css'
import axios from 'axios'
import { LOCALES_SOURCE, LOCALES_URL } from './config'
import { updateLocales } from './locales'
import scrollReveal from './directives/scroll-reveal'
import { notifyPrerenderReady } from './utils/prerender'

const requiredLocales = ['en', 'zh-cn', 'zh-tw']

const setFontPlatform = () => {
  const html = document.documentElement
  const ua = navigator.userAgent || ''
  const platform = navigator.platform || ''
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1)

  let platformClass = 'font-platform-default'
  if (isIOS) {
    platformClass = 'font-platform-ios'
  } else if (/Android/i.test(ua)) {
    platformClass = 'font-platform-android'
  } else if (/Win/i.test(platform) || /Windows/i.test(ua)) {
    platformClass = 'font-platform-windows'
  } else if (/Mac/i.test(platform) || /Macintosh/i.test(ua)) {
    platformClass = 'font-platform-macos'
  }

  html.classList.add(platformClass)
}

setFontPlatform()

Vue.directive('scroll-reveal', scrollReveal)
Vue.use(VueMeta)

// Initialize app logic.
const initApp = async () => {
  try {
    const res = await axios.get(LOCALES_URL, { timeout: 8000 })
    const remoteLocales = LOCALES_SOURCE === 'production-oss'
      ? res.data
      : res.data && res.data.code === 0 && res.data.data

    if (!remoteLocales || !requiredLocales.every(locale => typeof remoteLocales[locale] === 'object')) {
      throw new Error('Locales response is missing required languages')
    }

    updateLocales(remoteLocales)
    console.log(`Locales loaded from ${LOCALES_SOURCE}`)
  } catch (e) {
    console.error(`Failed to load locales from ${LOCALES_SOURCE}, using bundled defaults.`, e)
  } finally {
    const app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')

    router.onReady(() => {
      app.$nextTick(() => {
        app.$nextTick(() => {
          if (app.$meta) {
            app.$meta().refresh()
          }
          window.setTimeout(() => {
            notifyPrerenderReady()
          }, 0)
        })
      })
    })
  }
}

initApp()
